import { Button } from "antd";

const ApplicationStatusColumns = (goToUpdatePage, deleteApplicationStatus) => [
  {
    title: "Min. Versiyon",
    dataIndex: "minVersion",
    key: "minVersion",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Maks. Versiyon",
    dataIndex: "maxVersion",
    key: "maxVersion",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "İşletim Sistemi",
    dataIndex: "os",
    key: "os",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Zorunlu Güncelleme",
    dataIndex: "forceUpdate",
    key: "forceUpdate",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value.toString()}
      </span>
    ),
  },
  {
    title: "Önerilen Güncelleme",
    dataIndex: "recommendUpdate",
    key: "recommendUpdate",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value.toString()}
      </span>
    ),
  },
  {
    title: "Bakım Modu",
    dataIndex: "maintenanceMode",
    key: "maintenanceMode",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value.toString()}
      </span>
    ),
  },
  {
    title: "Uygulama",
    dataIndex: "app",
    key: "app",
    sorter: true,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value.description}
      </span>
    ),
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    key: "operations",
    fixed: "right",
    render: (_, record) => (
      <div style={{ display: "flex" }}>
        <Button type="link" onClick={() => goToUpdatePage({ record })}>
          Güncelle
        </Button>
        <Button
          type="link"
          danger
          onClick={() => deleteApplicationStatus({ record })}>
          Sil
        </Button>
      </div>
    ),
  },
];

export { ApplicationStatusColumns };
